<template>
  <QuickPost
    v-if="editMode"
    ref="quickpost"
    :width="getOptionValue(LayoutWidth)"
    :placeholder-text="getOptionValue(PlaceholderText)"
    :prompt-text="getOptionValue(QuickPostPrompt)"
    :show-character-count="getOptionValue(QuickPostShowCharacterCount)"
    :surface="getOptionValue(QuickPostSurface)"
    :image-aspect-ratio="getOptionValue(QuickPostImageShape)"
  />
  <iColumn v-else-if="canCreateQuickPost" gap="small" width="fill">
    <iRow align="center" wrap="nowrap">
      <QuickPost
        ref="quickpost"
        :is-loading="updatePostIsLoading"
        :placeholder-text="getOptionValue(PlaceholderText)"
        :max-length="memberPostMaxLength"
        :prompt-text="getOptionValue(QuickPostPrompt)"
        :show-character-count="getOptionValue(QuickPostShowCharacterCount)"
        :surface="getOptionValue(QuickPostSurface)"
        :image-aspect-ratio="getOptionValue(QuickPostImageShape)"
        @submit="submitPost"
      />
    </iRow>
    <iRow
      v-if="quickPostRefusal"
      align="left"
      gap="small"
      vertical-align="middle"
      width="fill"
    >
      <iText font-size="small" variant="error">
        {{ quickPostRefusal.message }}
      </iText>
      <iLink v-if="quickPostRefusal.retryable" @click="retryPost">
        Try again
      </iLink>
    </iRow>
  </iColumn>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { usePostFeedStore } from "SmartFeed/stores/feed/post-feed-store";
import QuickPost from "%/dynamic-component-editor/components/QuickPost.vue";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import { useStoryStore } from "%/dynamic-component-editor/stores/story-store";
import QuickPostOptions from "%/dynamic-component-editor/bundles/quick-post-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import { QuickPostElementMixin } from "%/dynamic-component-editor/standard-elements/quick-post/quick-post-element-mixin";

export default {
  name: "DynamicQuickPost",
  components: { QuickPost },
  mixins: [QuickPostElementMixin],
  elementPanelSettings: {
    displayName: "Quick Post",
    displayIcon: "paragraph",
    elementType: "element",
    elementGroup: "general",
  },
  optionBundles: [
    AppearanceOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
    }, {
      "max-height": true,
      "min-height": true,
      "min-width": true,
      "max-width": true,
    }),
    QuickPostOptions,
  ],
  data() {
    return {
      LayoutWidth,
      LayoutHeight,
      lastAttempt: null,
    };
  },
  computed: {
    ...mapState(useConfigurationStore, [
      "canCreateQuickPost",
      "publicationId",
      "ugcMaxLength",
    ]),
    memberPostMaxLength() {
      return Number(this.ugcMaxLength) || 0;
    },
    ...mapState(useStoryStore, [
      "updatePostIsLoading",
      "quickPostRefusal",
    ]),
  },
  methods: {
    usePostFeedStore,
    ...mapActions(useStoryStore, ["createQuickStory"]),
    submitPost(postData) {
      // The media picker persists a media id; a URL baked in at post time
      // cannot follow the media when it finishes transcoding or is replaced.
      if (postData["mediaId"]) {
        postData["image_segment"] = { mediaId: postData["mediaId"] };
      }
      delete postData["mediaId"];

      this.lastAttempt = postData;
      this.createQuickStory(this.publicationId, postData, (success, refusal) => {
        if (success) {
          this.lastAttempt = null;
          this.$refs.quickpost.reset();
          return;
        }
        if (refusal?.clearsImageOnly) {
          delete this.lastAttempt["image_segment"];
        }
      });
    },
    retryPost() {
      if (!this.lastAttempt) {
        return;
      }
      this.createQuickStory(this.publicationId, this.lastAttempt, success => {
        if (success) {
          this.lastAttempt = null;
          this.$refs.quickpost.reset();
        }
      });
    },
  },
};
</script>
